import { SIGNUP_IMAGES } from '../sign-up/sign-up.constants';
import { getZIndexByLayerName, LayerNames } from '../../../shared/constants/layers.constants';
import { ColorConstants, ImageConstants } from '../../../shared/constants';

export const FORGOT_Z_INDEX = getZIndexByLayerName(LayerNames.CURR_VALUE_999);
export const FORGOT_COLOR = ColorConstants['violent-violet'];

export const SIGN_IN_LOGO = ImageConstants.LOGOS.PARETO_BLUE.SRC;
export const SIGN_IN_BACKGROUND_IMAGE = SIGNUP_IMAGES.SIGN_IN.SRC;
export const SIGN_IN_BACKGROUND_COLOR = ColorConstants.white;
export const SIGN_IN_COLOR = ColorConstants['medium-slate-blue'];
export const SIGN_IN_TITLE_COLOR = ColorConstants['regal-blue'];
export const SIGN_IN_BUTTON_COLOR = ColorConstants.padua;


export const SIGN_IN_TEXT = {
    TITLE_TEXT: 'Sign In',
    SUB_TITLE_TEXT: 'Welcome to Pareto Ads',
    TITLE_PROJECT_TEXT: 'Pareto Ads',
    EMAIL_TEXT: 'Email',
    PASSWORD_TEXT: 'Password',
    BUTTON_TEXT_NEXT_STEP: 'Next',
    BUTTON_TEXT: 'Sign in',
    FORGOT_TEXT: 'Forgot password?',
    ALTERNATIVE_TEXT: 'or ',
    ALTERNATIVE_LINK_TEXT: 'Sign Up',
    TERMS_AND_PRIVACY_TEXT: 'Terms of Service and Privacy Policy',
    AZURE_ERROR_EMAIL_MISSING: 'The email field is not filled on the Azure Portal. Execute the following steps to fix it: go to portal.azure.com; find Users, find and select your User and fill the email field. After these steps, wait for 5~10 minutes and try again.',
};

export const SIGN_IN_WARNING_TEXTS = {
    '@auth/SIGN_IN_NETWORK_EXCEPTION_RAISED': `We are experiencing issues with our cloud providers, 
    affecting the Pareto Ads service availability. Please try again later.`,
};

export const TEST_ID = {
    SIGN_IN_PAGE: 'SIGN_IN_PAGE',
    SIGN_IN_USERNAME_INPUT: 'SIGN_IN_USERNAME_INPUT',
    SIGN_IN_PASSWORD_INPUT: 'SIGN_IN_PASSWORD_INPUT',
    SIGN_IN_PASSWORD_SHOW_CHECKBOX: 'SIGN_IN_PASSWORD_SHOW_CHECKBOX',
    SIGN_IN_SUBMIT_BUTTON: 'SIGN_IN_SUBMIT_BUTTON',
    SIGN_IN_MESSAGE: 'SIGN_IN_MESSAGE',
    SIGN_IN_LINK_TO_FORGOT_PASSWORD: 'SIGN_IN_LINK_TO_FORGOT_PASSWORD',
    SIGN_IN_LINK_TO_SIGN_UP: 'SIGN_IN_LINK_TO_SIGN_UP',
    SIGN_IN_AGREEMENT_LINK: 'SIGN_IN_AGREEMENT_LINK',
};

export const PLACEHOLDER_TEXTS = {
    email: 'maria@example.com',
    password: '*********',
};

const TEMPORARY_PASSWORD_EXPIRED = 'Temporary password has expired and must be reset by an administrator.';
const USER_DISABLED = 'User is disabled.';
export const INVALID_EMAIL_OR_NOT_FOUND = 'Please, provide a valid email. ';

export const ERROR_MESSAGES = {
    [TEMPORARY_PASSWORD_EXPIRED]: {
        formatted: 'This invite to Pareto Ads has expired. Please ask the person who invited you to resend the invitation.',
    },
    [USER_DISABLED]: {
        formatted: 'Your user is disabled. Please contact our support to access Pareto Ads.',
    },
};
